import CostsChart from "./CostsChart";
import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class CostsContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"COSTS"}
        // header={"ids_costs"}
        header={"ids_reports"}
        query={Queries.getCostsReportData}
        Chart={CostsChart}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(CostsContainer));
